import { Drawer } from 'antd'
import React from 'react'

import { drawerAndModalWidth } from '../../../util/guideline'
import { UpdateTenantLicenses } from './UpdateTenantLicenses'

interface UpdateTenantLicensesProps {
  tenantId: number
  isVisible: boolean
  onClose: () => void
  onSuccess: () => void
}

export const UpdateTenantLicensesDrawer = ({ tenantId, isVisible, onClose, onSuccess }: UpdateTenantLicensesProps) => (
  <Drawer
    title="Update Tenant Licenses"
    placement="right"
    onClose={onClose}
    open={isVisible}
    width={drawerAndModalWidth}
    destroyOnClose
  >
    <UpdateTenantLicenses tenantId={tenantId} onSuccess={onSuccess} />
  </Drawer>
)
